import React from 'react'

interface BusIconProps {
  className?: string;
}

const BusIcon: React.FC<BusIconProps> = ({ className }) => {
  return (

    <svg width="24" height="24" className={className} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M3 5H17L23 11V16H20.5C20.5 16.7956 20.1839 17.5587 19.6213 18.1213C19.0587 18.6839 18.2956 19 17.5 19C16.7044 19 15.9413 18.6839 15.3787 18.1213C14.8161 17.5587 14.5 16.7956 14.5 16H9C9 16.7956 8.68393 17.5587 8.12132 18.1213C7.55871 18.6839 6.79565 19 6 19C5.20435 19 4.44129 18.6839 3.87868 18.1213C3.31607 17.5587 3 16.7956 3 16H1V7C1 6.46957 1.21071 5.96086 1.58579 5.58579C1.96086 5.21071 2.46957 5 3 5ZM3 7V11H7V7H3ZM6 17.5C5.60218 17.5 5.22064 17.342 4.93934 17.0607C4.65804 16.7794 4.5 16.3978 4.5 16C4.5 15.6022 4.65804 15.2206 4.93934 14.9393C5.22064 14.658 5.60218 14.5 6 14.5C6.39782 14.5 6.77936 14.658 7.06066 14.9393C7.34196 15.2206 7.5 15.6022 7.5 16C7.5 16.3978 7.34196 16.7794 7.06066 17.0607C6.77936 17.342 6.39782 17.5 6 17.5ZM9 11H13V7H9V11ZM17.5 17.5C17.1022 17.5 16.7206 17.342 16.4393 17.0607C16.158 16.7794 16 16.3978 16 16C16 15.6022 16.158 15.2206 16.4393 14.9393C16.7206 14.658 17.1022 14.5 17.5 14.5C17.8978 14.5 18.2794 14.658 18.5607 14.9393C18.842 15.2206 19 15.6022 19 16C19 16.3978 18.842 16.7794 18.5607 17.0607C18.2794 17.342 17.8978 17.5 17.5 17.5ZM15 7V11H20L16 7H15Z" fill="#1E293B"/>
    </svg>
    
  )
}

export default BusIcon

